import { compose, withHandlers, withProps } from 'recompose';
import { connect } from 'react-redux';
import { change } from 'redux-form';

import PermissionCheckbox from './PermissionCheckbox';
import { withFormName } from '../../../../common/hoc/withFormName';
import { canUpdatePermission, updateDependentPermissions } from './helpers';
import withPermissions from '../../../../auth/utils/withPermissions';

export default compose(
  withFormName,
  withPermissions,
  connect(null, { change }),
  withProps(props => ({
    disabled:
      props.permissionData
        ? !canUpdatePermission(props.permissionData.fieldName, { permissions: props.permissions })
        : false,
  })),
  withHandlers({
    onChange: props => (e, newValue) => {
      updateDependentPermissions({
        permissionData: props.permissionData,
        newPermissionValue: newValue,
        formName: props.form,
        changeFormValue: props.change,
      });
    },
  }),
)(PermissionCheckbox);
